import { API_endpoints } from "../config";


export const getFAQs = async (): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.getFAQs, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({}),
        });
        if (!response.ok) {
            throw new Error("Fehler beim Laden von FAQs Daten.");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler beim Laden von FAQs Daten :", error);
        throw error;
    }
};
